var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckmarkGreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "checkmark_greenElement 156") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Isolationsmodus_Kopie_2",
    "data-name": "Isolationsmodus Kopie 2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.71227.01531A13.15859,13.15859,0,0,0,.02063,12.109a13.32253,13.32253,0,0,0,3.45816,9.663,12.66548,12.66548,0,0,0,8.96227,4.21879q.25689.00892.51108.0092A12.81051,12.81051,0,0,0,25.98953,13.388,12.65441,12.65441,0,0,0,13.71227.01531Z",
    fill: "#80b4ab"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.59888,6.959c-5.01932,2.4647-7.438,9.42411-8.61042,14.56364-.10363.45414-1.39315.47859-1.36215-.04251.19307-3.2443-2.84967-5.992-5.29877-7.72649-.54478-.38584.76209-.76661,1.17211-.47623a14.88121,14.88121,0,0,1,4.897,5.2436c1.45281-4.85221,4.00169-10.04685,8.46976-12.24084C20.40405,6.01609,21.41129,6.56,20.59888,6.959Z",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkGreen);
export default __webpack_public_path__ + "static/media/checkmark_green.805511ad364df01df74dab66e80e18e3.svg";
export { ForwardRef as ReactComponent };